import React from 'react';
import './login.css';
import LoginRight from './LoginRight';
import ForgotPasswordLeft from './ForgotPasswordLeft';

const ForgotPassword = () => {
  return (
    <div>
      <div className="slds-grid slds-wrap">
        <ForgotPasswordLeft />
        <LoginRight />
      </div>
    </div>
  );
};

export default ForgotPassword;
